import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import { IN_CA } from 'src/utils/constants'
import RedesignCalendarCarousel from '../RedesignCalendarCarousel'
import { Section } from '../CalendarTestimonials/styles'
import { Heading } from '../HomepageProducts/styles'

const RedesignCalendarTestimonials = ({ frame, buddy }) => {
  const {
    forwardImg,
    backImg,
    customerOneImg,
    customerTwoImg,
    customerThreeImg,
    customerFourImg,
    customerFiveImg,
    cjCustomerImg,
    jenniferCustomerImg,
    jessicaCustomerImg,
    laurenCustomerImg,
    melissaCustomerImg,
  } = useStaticQuery(graphql`
    query RedesignCalendarTestimonialsQuery {
      customerOneImg: file(relativePath: { eq: "calendar/customer-mary.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      customerTwoImg: file(relativePath: { eq: "calendar/customer-krista.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      customerThreeImg: file(relativePath: { eq: "calendar/customer-lucy.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      customerFourImg: file(relativePath: { eq: "calendar/customer-emily.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      customerFiveImg: file(relativePath: { eq: "calendar/customer-mark.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      backImg: file(relativePath: { eq: "calendar/arrow-left.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      forwardImg: file(relativePath: { eq: "calendar/arrow-right.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      cjCustomerImg: file(relativePath: { eq: "buddy/icons/cj_customer.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      jenniferCustomerImg: file(relativePath: { eq: "buddy/icons/jennifer_customer.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      jessicaCustomerImg: file(relativePath: { eq: "buddy/icons/jessica_customer.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      laurenCustomerImg: file(relativePath: { eq: "buddy/icons/lauren_customer.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
      melissaCustomerImg: file(relativePath: { eq: "buddy/icons/melissa_customer.webp" }) {
        childImageSharp {
          gatsbyImageData(quality: 100, layout: FULL_WIDTH, placeholder: NONE)
        }
      }
    }
  `)
  const customerImages = [
    customerOneImg,
    customerThreeImg,
    customerFourImg,
    customerFiveImg,
    customerTwoImg,
  ]
  const caCustomerImages = [
    customerOneImg,
    customerThreeImg,
    customerFourImg,
    customerTwoImg,
    customerFiveImg,
  ]
  const buddyCustomerImages = [
    jenniferCustomerImg,
    jessicaCustomerImg,
    laurenCustomerImg,
    melissaCustomerImg,
    cjCustomerImg,
  ]
  return (
    <Section>
      <Heading center>{buddy ? 'Featured Stories' : 'Share the Love'}</Heading>
      <RedesignCalendarCarousel
        forwardImg={forwardImg}
        backImg={backImg}
        images={buddy ? buddyCustomerImages : IN_CA ? caCustomerImages : customerImages}
        frame={frame}
        buddy={buddy}
      />
    </Section>
  )
}

RedesignCalendarTestimonials.propTypes = {
  frame: PropTypes.bool,
  buddy: PropTypes.bool,
}

export default RedesignCalendarTestimonials
